import { Employee } from '../employee/employee';
import { Role } from './role';

export class User {
	id: number;
	login: string;
	email: string;
	password: string;
	previousPassword?: string;
	role: Role;
	employee: Employee;
	firstLogin: boolean;
	active: boolean;

	constructor(
		options: {
			id?: number;
			login?: string;
			password?: string;
			role?: Role;
			employee?: Employee;
			firstLogin?: boolean;
		} = {}
	) {
		this.id = options.id || 0;
		this.login = options.login || null;
		this.password = options.password || null;
		this.role = options.role || new Role();
		this.employee = options.employee || null;
		this.firstLogin = options.firstLogin || true;
	}
}
